import { UserCard } from '@widgets/user';
import type { User } from '@entities/user';

type UserInfoRecruiterProps = {
  user: User;
  editLink: string;
};

export const UserInfoRecruiter = ({
  user,
  editLink,
}: UserInfoRecruiterProps) => {
  return (
    <UserCard
      isEdit
      firstName={user.profile.firstName}
      lastName={user.profile.lastName}
      email={user.email}
      group={user.role.name}
      company={user?.company?.name}
      phone={user.profile.phone}
      editLink={editLink}
    />
  );
};
